import { initGuards, router } from '@/router';
import domus, { HgSupportedLanguage, type SupportedPlatforms } from '@smg-real-estate/domus';
import { createExperiments } from '@smg-real-estate/openfeature-vue';
import { VueHeadClient, createHead } from '@unhead/vue/client';
import { createPinia, type Pinia } from 'pinia';
import { createSSRApp, type App, type Component } from 'vue';
import { type I18n } from 'vue-i18n';
import { type Router } from 'vue-router';

export function createVueApp(
  appComponent: Component,
  i18n: I18n,
  platform: SupportedPlatforms,
): {
  app: App<Element>;
  router: Router;
  pinia: Pinia;
  head: VueHeadClient;
} {
  const pinia = createPinia();
  const head = createHead();
  initGuards(router);

  const app = createSSRApp(appComponent);
  app.use(i18n);
  app.use(router);
  app.use(pinia);
  app.use(createExperiments());
  app.use(head);

  // needs to be last as domus sets the locale when all translations are loaded
  app.use(domus, {
    theme: platform,
    i18n: { instance: i18n, languages: { name: 'all', mode: 'lazy' } },
    router: { instance: router, defaultLanguage: HgSupportedLanguage.DE },
  });

  return { app, router, pinia, head };
}
